/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRocketIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-rocket"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.92 22.35Q4.28 22.63 3.71 22.23Q3.15 21.82 3.15 21.13L3.15 16.65Q3.15 16 3.46 15.39Q3.77 14.78 4.33 14.43L5.65 13.55Q5.85 15.6 6.24 17.27Q6.63 18.95 7.47 21.32ZM10.32 20.48Q9.93 20.48 9.57 20.21Q9.22 19.95 9.05 19.52Q8.2 17.4 7.9 15.86Q7.6 14.32 7.6 12.22Q7.6 9.7 8.51 7.3Q9.43 4.9 11.03 3.25Q11.22 3.05 11.47 2.96Q11.72 2.88 12 2.88Q12.28 2.88 12.53 2.96Q12.78 3.05 12.97 3.25Q14.57 4.9 15.49 7.3Q16.4 9.7 16.4 12.22Q16.4 14.35 16.11 15.84Q15.82 17.32 14.95 19.52Q14.78 19.95 14.43 20.21Q14.07 20.48 13.68 20.48ZM12 12.82Q12 12.82 12.36 12.82Q12.72 12.82 13.24 12.31Q13.75 11.8 13.75 11.07Q13.75 10.35 13.24 9.84Q12.72 9.32 12 9.32Q11.28 9.32 10.76 9.84Q10.25 10.35 10.25 11.07Q10.25 11.8 10.76 12.31Q11.28 12.82 12 12.82ZM19.05 22.35L16.5 21.32Q17.35 18.95 17.74 17.27Q18.13 15.6 18.32 13.55L19.65 14.43Q20.2 14.78 20.51 15.39Q20.82 16 20.82 16.65L20.82 21.13Q20.82 21.82 20.26 22.23Q19.7 22.63 19.05 22.35Z" fill={color} />
    </svg>
  );
}
